module.exports = __webpack_public_path__ + "img/graph-1c.0788070c.png";